export default function createProps(
  propTypes,
  { style = '', ...props },
  classNames,
  styles = [],
) {
  const newProps = {}

  Object.keys(props)
    .filter((key) => key === 'children' || !propTypes[key])
    .forEach((key) => (newProps[key] = props[key]))

  const className = classNames.filter((cn) => cn).join(' ')

  return Object.assign(
    {},
    newProps,
    { className },
    {
      style: {
        ...style,
        ...styles.reduce((acc, cn) => {
          const [k, v] = cn.split(':')
          return { ...acc, [k]: v }
        }, {}),
      },
    },
  )
}
